export default {
  /** 路由 */
  route: {
    首页: 'Home',

    一级菜单: 'First Menu',
    二级菜单: 'Secondary Menu',
  },

  /** 头部导航提示 */
  header: {
    systemTitle: 'Load aggregation management platform',
    plat: 'Load aggregation management platform',
    menuSearch: 'Menu search',
    playSound: 'Play sound',
    refresh: 'Refresh',
    fullscreen: 'Full screen',
    languageChange: 'Language switching',
    zh: 'Chinese',
    en: 'English',
    langMessage: 'Language switch succeeded',
    themeChange: 'Theme switching',
    light: 'State Grid Green',
    dark: 'Technology Blue',
    boldDark: 'Bold Dark',
    themeMessage: 'Theme switch succeeded',
    layoutLogin: 'Log out',
  },

  /** placeholder */
  placeholder: {
    search: 'Please Enter the Menu Name',
  },

}